import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative text-base group sm:text-sm" }
const _hoisted_2 = { class: "p-1 overflow-hidden group-hover:opacity-75" }
const _hoisted_3 = ["href", "title"]
const _hoisted_4 = { class: "aspect-3/2 opp-img guide-img-container" }
const _hoisted_5 = ["src", "alt", "title"]
const _hoisted_6 = { class: "flex flex-col px-1 mt-3" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = { class: "px-2 py-1 mb-2 text-sm text-gray-900 rounded-md bg-slate-100" }
const _hoisted_10 = {
  key: 0,
  class: "hidden py-2 text-sm text-gray-600 md:col-span-2"
}
const _hoisted_11 = ["href", "title"]
const _hoisted_12 = { class: "" }


import {OpportunityDTOLightweight} from "@/dtos";
import {LightBulbIcon} from "@heroicons/vue/20/solid";


export default /*@__PURE__*/_defineComponent({
  __name: 'OpportunityCardMinimal',
  props: {
    opportunity: {}
  },
  setup(__props: any) {

const props = __props;

const opportunity = props.opportunity;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: `/${_unref(opportunity).id}/${_unref(opportunity).slug}`,
        title: _unref(opportunity).title
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "object-cover rounded-lg shadow-lg aspect-3/2",
            src: _unref(opportunity).imageUrl,
            alt: _unref(opportunity).title,
            title: _unref(opportunity).title
          }, null, 8, _hoisted_5)
        ])
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("dl", _hoisted_6, [
      _createElementVNode("dd", {
        class: "mt-1 text-xs",
        title: _unref(opportunity).regionName
      }, _toDisplayString(_unref(opportunity).regionName), 9, _hoisted_7),
      _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "sr-only" }, "Category", -1)),
      _createElementVNode("dd", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(opportunity).category), 1)
      ]),
      (_unref(opportunity).isPostedByProMember)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_unref(LightBulbIcon), { class: "w-5 h-5 text-sa-red-600" }),
            _cache[0] || (_cache[0] = _createTextVNode(" Pro Posted! "))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("a", {
      href: `/${_unref(opportunity).id}/${_unref(opportunity).slug}`,
      title: _unref(opportunity).title,
      class: "block px-1 mt-2 font-medium hover:underline"
    }, [
      _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(opportunity).title), 1)
    ], 8, _hoisted_11)
  ]))
}
}

})